import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { pick } from 'lodash';
import { PaginationFields } from '@/models/pagination.model';
import { getLinkingTools, createInterLink, updateInterLink, deleteInterLink, importInterLink } from './actionCreators';
import { InterLinksState, SLICE_NAME, initialState } from './models';

export const interLinksSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLinkingTools.fulfilled, (state: InterLinksState, action) => {
        const { payload } = action;
        state.interLink = payload?.sections ?? [];
        state.pagination = pick(payload, [PaginationFields.PAGE_SIZE, PaginationFields.TOTAL, PaginationFields.PAGE]);
        state.isLoading = false;
      })
      .addCase(createInterLink.fulfilled, (state: InterLinksState) => {
        state.isLoading = false;
      })
      .addCase(updateInterLink.fulfilled, (state: InterLinksState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.interLink = (state.interLink ?? []).map((interLink) => {
          if (interLink.id === payload.id) return payload;
          return interLink;
        });
      })
      .addCase(deleteInterLink.fulfilled, (state: InterLinksState, action) => {
        const { meta } = action;
        state.isLoading = false;
        state.interLink = (state.interLink ?? []).filter((interLink) => interLink.id !== meta.id);
      })
      .addCase(importInterLink.fulfilled, (state: InterLinksState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.importResult = payload;
      })
      .addMatcher(
        isPending(getLinkingTools, createInterLink, updateInterLink, deleteInterLink, importInterLink),
        (state: InterLinksState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(getLinkingTools, createInterLink, updateInterLink, deleteInterLink, importInterLink),
        (state: InterLinksState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
